(function (Cobalt) {
    var Table = /** @class */ (function () {
        function Table() {
        }
        Table.EnableMobileNavigation = function (tableSelector, linkSelector) {
            var _this = this;
            ///<summary>
            /// Enable mobile navigation for a table. There must be an anchor tag within each row with the destination href for this to work.
            ///</summary>
            ///<param name="tableSelector">A string selector for the table</param>
            ///<param name="linkSelector">The jQuery selector for the anchor tag within a table row. Clicking the row will navigate the user the href found on this anchor tag</param>
            this.registerRowClickHandler(tableSelector, linkSelector);
            $(window).on("resize", function () {
                _this.registerRowClickHandler(tableSelector, linkSelector);
            });
        };
        Table.registerRowClickHandler = function (tableSelector, linkSelector) {
            var winWidth = $(window).width();
            $(tableSelector + " tr").each(function () {
                // remove event handlers
                $(this).off("click", Cobalt.Table.rowClickHandler);
                //only activate full row navigation is window width is below or equal to 640
                var data = { 'linkSelector': linkSelector };
                if (winWidth <= 640) {
                    $(this).on("click", data, Cobalt.Table.rowClickHandler);
                }
            });
        };
        Table.rowClickHandler = function (event) {
            var url = $(this).find(event.data.linkSelector).attr("href");
            event.preventDefault();
            if (url != "undefined") {
                window.location.href = url;
            }
        };
        return Table;
    }());
    Cobalt.Table = Table;
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Table.js